import { formatDate } from '@angular/common';

export const APP_DATE_LOCALE = 'ru-RU';
export const APP_DATE_TIMEZONE = 'GMT+0300';
export const APP_DATE_TIMEZONE_OFFSET = '+03:00';

function normalizeAppTime(time: string): string {
  if (!time) {
    return '12:30:00';
  }

  if (/^\d{2}:\d{2}$/.test(time)) {
    return `${time}:00`;
  }

  return time;
}

export function createAppDate(date: string, time: string = '12:30'): Date {
  return new Date(`${date}T${normalizeAppTime(time)}${APP_DATE_TIMEZONE_OFFSET}`);
}

export function formatAppDate(
  value: Date | string | number,
  format: string,
  locale: string = APP_DATE_LOCALE,
): string {
  return formatDate(value, format, locale, APP_DATE_TIMEZONE);
}
